enum RoomEnum {
    SUPPLIER = "supplier",
}

export default RoomEnum;
